import React from 'react';
import { motion } from 'framer-motion';
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import header from '../asset/header_1.jpeg';
import blog1 from '../asset/blog_1.jpeg';
import blog2 from '../asset/blog_2.jpeg';
import blog3 from '../asset/blog_9.jpeg';
import blog4 from '../asset/blog_4.jpeg';
import blog5 from '../asset/blog_8.jpeg';
import blog6 from '../asset/blog_10.jpeg';
import image1 from '../asset/temoin.jpg';
import image2 from '../asset/temoin2.jpg'; 
import image3 from '../asset/temoin1.jpg'; 
import image4 from '../asset/temoin4.jpg';

const evenements = [
  { 
    image: `${blog1}`, 
    alt: "Visite à Pointe-Noire",
    title: "Conférence d'informations",
    date: "Avril 2025",
    description: "Une soirée élégante pour un partage d'idées et de connaissances"
  },
  { 
    image: `${blog2}`, 
    alt: "Visite à Dolisie",
    title: "Présentation des programmes",
    date: "Avril 2025",
    description: "Apprenez des experts dans notre domaine"
  },
  { 
    image: `${blog3}`, 
    alt: "Conférence à Brazzaville",
    title: "Etudier dans une école de commerce en France",
    date: "Avril 2025",
    description: "Débats et échanges avec des leaders d'opinion"
  },
  { 
    image: `${blog4}`, 
    alt: "Visite des écoles de la place",
    title: "Les possibilités d'études à l'étranger",
    date: "Avril 2025",
    description: "Présentation de nos programmes et de nos partenaires"
  },
  { 
    image: `${blog5}`, 
    alt: "Conférence à Brazzaville",
    title: "Comment réussir son entretien",
    date: "Avril 2025",
    description: "Discutez avec des experts sur les meilleures pratiques"
  },
  { 
    image: `${blog6}`, 
    alt: "Conférence à Brazzaville",
    title: "Comment réussir ses études en france",
    date: "Avril 2025",
    description: "Discutez avec des experts sur les meilleures pratiques"
  },
];

const Blog = () => {
  const handleScroll = (e) => {
    e.preventDefault();
    const nextSection = document.getElementById('content');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        {/* Image de fond avec overlay */}
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center 30%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        {/* Navbar */}
        <TopNavbarre/>
        
        {/* Contenu principal centré verticalement */}
        <div className="relative z-10 flex-grow flex items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              {/* Titre principal avec animation */}
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-2 sm:mb-4"
              >
                Conseils,<span className="text-blue-400"> actualités</span>
              </motion.h1>
              
              {/* Sous-titre */}
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-lg"
              >
                Restez informé sur les opportunités d’études à l’international et découvrez les parcours inspirants de nos étudiants.
              </motion.p>
              
              {/* Groupe de boutons */}
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex flex-col sm:flex-row gap-3 sm:gap-4"
              >
                <a
                  href="#services"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                  onClick={(e) => {
                    e.preventDefault();
                    const servicesSection = document.getElementById('services');
                    if (servicesSection) {
                      servicesSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  Retour en images
                </a>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* Indicateur de défilement */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#services" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      {/* Section Événements */}
      <section
        id="services" // Ajout de l'id pour cibler cette section
        className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900"
      >
        <div className="max-w-7xl mx-auto">
          {/* Titre avec animation */}
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Nos <span className="text-yellow-400">Événements</span>
            </h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto"></div>
            <p className="mt-6 text-lg text-blue-100 max-w-2xl mx-auto">
              Découvrez nos prochains événements et rejoignez notre communauté pour des moments inoubliables.
            </p>
          </motion.div>

          {/* Grille d'événements */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {evenements.map((event, index) => (
              <motion.div 
                key={index} 
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 bg-white text-gray-800"
              >
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <h3 className="text-xl font-bold mb-1">{event.title}</h3>
                  <p className="text-yellow-300 mb-2">{event.date}</p>
                  <p className="text-gray-200">{event.description}</p>
                </div>
                
                {/* <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-1">{event.title}</h3>
                  <p className="text-blue-600 font-medium mb-3">{event.date}</p>
                  <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300">
                    En savoir plus
                  </button>
                </div> */}
              </motion.div>
            ))}
          </div>

          {/* Bouton Voir plus */}
          {/* <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="text-center mt-12"
          >
            <button className="px-8 py-3 bg-yellow-400 text-blue-900 font-semibold rounded-full hover:bg-yellow-500 hover:text-white transition-all duration-300 shadow-md hover:shadow-lg">
              Voir tous les événements
            </button>
          </motion.div> */}
        </div>
      </section>

      <section
        id="temoignages"
        className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900"
      >
        <div className="max-w-7xl mx-auto">
          {/* Titre de la section */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Témoignages <span className="text-yellow-400">d'étudiants</span>
            </h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto"></div>
            <p className="mt-6 text-lg text-blue-100 max-w-2xl mx-auto">
              Découvrez les retours d'expérience de nos étudiants qui ont réalisé leur rêve d'étudier à l'étranger.
            </p>
          </motion.div>

          {/* Grille des témoignages */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Témoignage 1 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 bg-white text-gray-800"
            >
              <div className="relative w-full h-0 pb-[100%] overflow-hidden">
                <img
                  src={image1} // Remplacez par le chemin de votre image
                  alt="Témoignage étudiant 1"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">MOUANDA MISSENGUE</h3>
                <p className="text-gray-600">
                  Grâce à France Études, j'ai pu intégrer une université prestigieuse en France. Leur accompagnement a été exceptionnel !
                </p>
              </div>
            </motion.div>

            {/* Témoignage 2 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 bg-white text-gray-800"
            >
              <div className="relative w-full h-0 pb-[100%] overflow-hidden">
                <img
                  src={image2} // Remplacez par le chemin de votre image
                  alt="Témoignage étudiant 2"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">TOUKOU LEMBET</h3>
                <p className="text-gray-600">
                  L'équipe m'a aidé à préparer mon dossier et à réussir mon entretien. Je recommande vivement leurs services !
                </p>
              </div>
            </motion.div>

            {/* Témoignage 3 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 bg-white text-gray-800"
            >
              <div className="relative w-full h-0 pb-[100%] overflow-hidden">
                <img
                  src={image3}// Remplacez par le chemin de votre image
                  alt="Témoignage étudiant 3"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">OHOUSSI & NKOUNGA</h3>
                <p className="text-gray-600">
                  Une expérience incroyable ! Merci à toute l'équipe pour leur soutien tout au long de mon parcours.
                </p>
              </div>
            </motion.div>
            {/* Témoignage 3 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 bg-white text-gray-800"
            >
              <div className="relative w-full h-0 pb-[100%] overflow-hidden">
                <img
                  src={image4}// Remplacez par le chemin de votre image
                  alt="Témoignage étudiant 3"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">NAMOUTIRIRI</h3>
                <p className="text-gray-600">
                  Une expérience incroyable ! Merci à toute l'équipe pour leur soutien tout au long de mon parcours.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer/>
    </div>
  );
};

export default Blog;